import { render, staticRenderFns } from "./Physiotherapy.vue?vue&type=template&id=a0f6156c&"
import script from "./Physiotherapy.vue?vue&type=script&lang=ts&"
export * from "./Physiotherapy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports